// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap'); */

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* font-family: 'Poppins', sans-serif; */
}

.cursorDefault {
  cursor: default !important;
  border-radius: 50% !important;
}

/* .chatpage {
  border-top: 1px solid #eee;
} */
.mobileView svg:not(.moreBox){
  /* // fill: #fff !important; */
  color: #000000 !important;
  filter: brightness(0) invert(1) !important
  /* // stroke: #fff !important; */
}
.mobileView div:not(.ThemeBox) p:not(.preserveStyle), .mobileView input, .mobileView input::placeholder {
  color: #fff !important;
}
.exitButton {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  /* color: #D8000D;
  border: 1px solid #D8000D; */
  color: white;
  background-color: #d8000d;
  /* background: #FFFFFF; */
  border-radius: 4px;
  width: 134px;
  ;
  height: auto;
  aspect-ratio: 4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: auto;
  cursor: pointer;
}

.date {
  font-size: 11px;
  width: auto;
}

.lastMessage {
  color: #999 !important;
  font-size: 12px !important;
}

.flex-1 {
  flex: 1 1 !important;
}

.chatbarText {
  margin: 0 8px;
}

.home__container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home__container>* {
  margin-bottom: 10px;
}

.home__header {
  margin-bottom: 30px;
}

.username__input {
  padding: 10px;
  width: 50%;
}

.home__cta {
  width: 200px;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  background-color: #607EAA;
  color: #fbfbfb;
  outline: none;
  border: none;
  border-radius: 5px;
}

.chat {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex: 1 1;
  overflow-y: auto;
}

.userButton {
  display: none;
}

.closeBtn {
  display: none;
}

.chat__sidebar {
  height: 100%;
  box-sizing: border-box;
  /* padding:0 20px; */
  /* background-color: #fbfbfb; */
  /* flex: 0.2; */
  /* width:20%; */
  /* padding: 20px; */
  /* border-right: 1px solid #fdfdfd; */
  /* overflow-y: auto; */

  /* scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 5px; */
}

.chat__sidebar>div {
  /* height:100%; */
}

.flex-02 {
  /* flex: 0.3; */
  width: 24%;
}

.noContent {
  display: block;
}

.chat__main {
  height: 100%;
  flex: 1 1;
  /* padding-bottom: 10px; */
  width: 70vw;
}

.chat__header {
  /* margin: 30px 0 20px 0; */
}

.chat__users {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-y: auto;
  height: calc(100vh - 134px);
  /* height: calc(100vh - 200px); */
  /* scrollbar-color: #e3e3e3 transparent; */
  scrollbar-width: 5px;
  margin-top: 5px;
}

.onlineLoader {
  height: calc(100vh - 150px);
}

.chat__users>* {
  margin-bottom: 5px;
  margin-top: 5px;
  /* color: #607EAA !important; */
  font-size: 14px;
}

.chat__users p {
  margin-right: 5px;
}

.chat__users>div {
  width: 100%;
  margin: 10px 0;
  height: auto;
  padding: 10px 10px;
  margin: 10px 0;
  border-radius: 4px;
}

.chat__users::-webkit-scrollbar {

  background: transparent;
  width: 5px;
}

.chat__users::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 100px;
  height: 5px;
}

.online__users>* {
  margin-bottom: 10px;
  color: rgb(238, 102, 102);
  font-style: italic;
}

.chat__mainHeader {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  /* background-color: #fbfbfb; */
}

.footer__border {
  /* border-top: 1px solid #ddd; */
}

.chatBarInput input {
  min-height: 28px;
}

.replyChatStyle {
  color: #d8000d;
  cursor: pointer;
  font-size: 11px;
  /* width:20px; */
  /* height:20px; */
}

.replyBox {
  /* position: absolute; */
  /* width: 100%; */
  width: calc(100% - 20px);
  /* height: 50px; */
  /* bottom: 83px; */
  bottom: 90px;
  left: 10px;
  /* padding: 14px; */
  /* border-top-right-radius: 8px;
  border-top-left-radius: 8px; */
  display: flex;
  z-index: 2;
  /* flex-direction: column; */
  /* justify-content: flex-start; */
  /* align-items: flex-start; */
  justify-content: space-between;
  align-items: center;
  /* background: linear-gradient(
    200.96deg,
    #eee -29.09%,
    #fff 51.77%,
    #eee 129.35%
  ); */
  /* box-shadow: 0px 0px 2px rgb(0 0 0 / 9%), 0px 1px 5px rgb(0 0 0 / 9%); */

  /* box-shadow: 0px 4px 9px rgb(0 0 0 / 9%); */
}

.blockFooter {
  padding-top: 10px;
  margin-top: auto;
  position: absolute;
  width: 100%;
  bottom: 0;
  padding-bottom: 10px;
  padding-top: 10px;
  text-decoration: unset !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.blockFooter p {
  cursor: pointer;
  width: auto !important;
}

.replyBox p,
.replyBox div {
  font-size: 12px;
  /* word-break: break-all; */
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  /* display: -webkit-box; */
  display:flex;
  -webkit-line-clamp: 2;
  -moz-text-size-adjust: auto;
  /* text-align: right; */
  /* width: 100%; */
  /* padding: 0 10px; */
  color: rgba(0, 0, 0, 0.50);
font-size: 11px;
font-style: normal;
font-weight: 400;
line-height: normal;

}
.replyBox> div{
  padding: 0 10px;
}


/* .replyBox svg{
  rotate: 180deg;
} */
.replyFile {
  max-width: 10%;
  height: auto !important;
  margin-right: 10px;
  margin-left: 10px;
  max-width: 40px; 
      max-height: 40px;
  /* max-height:78px; */
}

/* .replyFile img, .replyFile video{
  max-height:78px;
} */
.unseenMessages {
  /* position:absolute;
  bottom:-5px;
  right:-5px; */
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 2px;
  color: #fff;
  /* background-color: #e86e77; */
  width: 19px;
  height: 19px;
  font-size: 11px;
  border-radius: 50%;

}

.onlineUser {



  /* position: absolute;
    bottom: -2px;
    width: 12px;
    height: 12px;
    right: -2px;
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 2px;
    color: #fff;
    font-size: 11px;
    border-radius: 50%;
    background-color: #19e219;
    border: 1px solid #fff; */

  position: absolute;
  bottom: -1px;
  width: 9px !important;
  height: 9px !important;
  /* left: 0px; */
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 2px;
  color: #fff;
  /* background-color: #075b52; */
  font-size: 11px;
  border-radius: 50%;
  background-color: #19e219;
  /* /* border: 1px solid #fff; */


}

.offlineUser {

  position: absolute;
  bottom: -2px;
  width: 12px;
  height: 12px;
  right: -2px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 2px;
  color: #fff;
  background-color: #dfc8c8;
  font-size: 11px;
  border-radius: 50%;
  border: 2px solid #777;

}

.commentReply {

  /* color: #aaa; */
  color: #607EAA !important;
  padding: 0 5px;
  margin: 5px 0;
  padding: 0 5px;
  font-size: 11px;

  width: 100%;
  overflow: hidden;
}

code,
pre {
  white-space: pre;
  font-family: IranSans_Light
}

#text {
  word-break: break-all;
  display: flex;
  flex-wrap: wrap;
  display: inline;
}

.onlineUserRtl {
  left: 0 !important;
  right: unset !important;
}

.onlineUserLtr {
  left: unset !important;
  right: 0 !important;
}

.rtl .commentReply {
  border-left: 3px solid #607EAA;
}

.ltr .commentReply {
  /* border-right: 3px solid #607EAA; */
}

/* .rtl .commentReply>div:nth-child(1){
  margin-bottom: 10px;
  margin-left: auto;
}
.ltr .commentReply>div:nth-child(1){
  margin-bottom: 10px;
  margin-right: auto;
} */
.commentReply p {

  /* color: #aaa; */
  color: #607EAA !important;
  margin-bottom: 2px;
  margin-top: 2px;

}

.leaveChat__btn {
  padding: 10px;
  width: 150px;
  border: none;
  outline: none;
  background-color: #D1512D !important;
  cursor: pointer;
  color: #EAE3D2;

  width: 150px;
  padding: 10px;
  /* border: none; */
  /* outline: none; */
  /* color: #EAE3D2; */
  cursor: pointer;
  color: #fff;
  height: 100%;
  margin-right: auto !important;
  display: flex !important;
}

.message__container {
  width: 100%;
  height: calc(100vh - 140px);
  min-height: calc(100vh - 140px);
  /* background-color: #fff; */
  /* padding: 20px; */
  overflow-y: auto;
  /* scrollbar-color: #e3e3e3 transparent; */
  display: flex;
  justify-content: flex-start;
  /* align-items: flex-start; */
  flex-direction: column;
  scrollbar-width: 8px;
}

.message__containerScrollbarW {
  scrollbar-color: #e3e3e3 transparent;
}

.message__containerScrollbarD {
  scrollbar-color: #555555 transparent;
}

.userMessage {
  padding: 4px 8px;
  width: auto;
  background-color:#909090;
  /* background: rgba(0, 0, 0, 0.6); */
  border-radius: 28px;
  color: #fff;
  /* min-width: 35%; */
  width:auto;
  margin: 4px auto;
  font-size: 14px;
}

.dragFileElement {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: rgba(200, 200, 200, 0.5)
}

.repeatBg {
  /* background-size: 200px !important; */
  background-repeat: repeat;
  background-position: unset;
}

.noRepeatBg {
  /* background-size: 543px !important; */
  background-repeat: no-repeat;
  background-position: center;
}

.coverBg {
  background-size: cover !important;
}

.message__container::-webkit-scrollbar {

  background: transparent;
  width: 8px;
}

.message__container::-webkit-scrollbar-thumb {
  /* background-color: #e3e3e3; */
  border-radius: 100px;
  height: 8px;
}

.message__container>* {
  /* margin-bottom: 10px; */
}

.chat__footer {
  /* padding: 10px 0; */
  padding-bottom: 0px;
  /* background-color: #fbfbfb; */
  height: 60px;
  width: 100%;
  box-sizing: border-box;
}

.form {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.message {
  width: 80%;
  height: 100%;
  border-radius: 10px;
  border: 1px solid #ddd;
  outline: none;
  padding: 15px;
  height: 36px;
}

.sendBtn {
  width: 150px;
  /* background-color: green !important; */
  padding: 10px;

  cursor: pointer;
  color: #fff;
  height: 100%;
  display: flex !important;
  border: unset !important;

}

.message__recipient video,
.message__sender video {
  margin: 0 auto !important;
  height: auto !important;
  width: 100%;
}

.commentReply img,
.commentReply video {
  margin-left: 10px !important;
  /* margin-right:auto !important; */
  width: 100%;

}

.message__recipient img,
.message__sender img {
  width: 100%;
}

.sendBtn:hover {
  background-color: rgb(129, 201, 129) !important;
}

.message__recipient {
  /* background-color: #f5ccc2 !important; */
  /* min-width: 300px !important;
  max-width: 350px; */
  min-width: 225px !important;
  max-width: 250px;
  width: auto;
  padding: 10px 8px;
  padding-top: 20px;
  border-radius: 10px;
  font-size: 15px;
  /* word-break: break-all; */
  /* overflow: hidden; */

  float: right;
  clear: both;
  border-top-right-radius: 0px;
  /* background: #00D025; */
  position: relative;
  border-top-left-radius: 0px;
}

.message__sender {
  /* background-color: rgb(194, 243, 194); */
  min-width: 225px !important;
  max-width: 250px;
  padding: 10px 8px;
  padding-top: 20px;
  width: auto;
  border-radius: 10px;
  border-top-right-radius: 0px;
  /* margin-left: auto; */
  font-size: 15px;
  /* background-color: rgb(129, 201, 129) !important; */

  /* word-break: break-all; */
  /* overflow: hidden; */

  float: left;
  clear: both;
  border-top-left-radius: 0px;
  position: relative;

}

/* .chat.u2{
  float: right;
  clear: both;
  border-top-right-radius: 0px;
  background: #00D025;
}
.chat.u2:before{
  content: "";
  width: 0px;
  height: 0px;
  display: block;
  border-left: 5px solid #00D025;
  border-right: 5px solid transparent;
  border-top: 5px solid #00D025;
  border-bottom: 5px solid transparent;
  position: absolute;
  top: 0px;
  right: -10px;
} */

/* .senderBackgroundGray{
  background-color: rgba(255,255,255,0.2) !important;
}
.senderBackgroundWhite{
  background-color: rgba(0,0,0,0.1) !important;
} */
.message__chats {
  padding: 10px 0;
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: auto;
  cursor: alias;
}

.message__chats>p {
  font-size: 13px;
  line-height: 20px;
}

.sender__name {
  text-align: right;
}

.message__status {
  /* position: fixed; */
  /* bottom: 50px;
  font-size: 13px;
  font-style: italic; */

  position: fixed !important;
  bottom: 70px;
  margin: 0 10px;
  font-size: 13px;
  font-style: italic;

}

.onlineChatInput {
  color: #fff;
}

.custom-file-upload input[type="file"] {
  display: none;
}

.custom-file-upload {
  width: fit-content;
  cursor: pointer;
  border-radius: 24px;
  border: 1px solid #eeeeee;
  padding: 8px 18px;
  margin: 4px;
  background-color: #fafafa;
  font-size: 14px;
  display: inline-block;
  height: 36px;
  /* width: 150px; */
  background-color: inherit !important;
  /* border: 1px solid green; */
  /* border: none; */
  /* outline: none; */
  /* color: #EAE3D2; */
  cursor: pointer;
  /* color: green; */
  display: flex !important;
  justify-content: center;
  min-width: 64px;
  /* border: unset !important; */

}

/* .custom-file-upload:hover {
  color: rgb(129, 201, 129) !important;
  border: 1px solid rgb(129, 201, 129);
} */
.disableUpload,
.disableUpload:hover {
  color: #ccc !important;
  border: 1px solid #ccc !important;
  cursor: default !important;
}

.usersBorderWhite {
  margin-top: 10px;
  /* border-left: 1px solid #ccc; */
}

.usersBorderGray {
  /* border-left: 1px solid #555; */
}

/* @media only screen and (max-width: 850px) {
  .message__container {
    width: 100%;
    height: calc( 100% - 56px) !important;
  }
  .onlineLoader{
    height: calc( 100% - 56px) !important;
  }
} */
@media only screen and (max-width: 800px) {
  .chat {
    /* flex:0.75; */
  }

  .chat__sidebar {
    /* position:absolute;
    z-index:1;
    right:0;
  /* box-shadow: 0px 4px 9px rgb(0 0 0 / 9%); */
    /* top:5px; */
    /* width:30vw !important; */
  }

  .replyBox {
    width: calc(100% - 20px);
    bottom: 90px;
    /* bottom: 106px; */
    /* bottom: 103px; */
  }

  .flex-02 {
    /* flex: 0.3; */
    width: 34%;
  }
}

@media only screen and (max-width: 650px) {
  .noContent {
    display: none;
  }

  .replyBox {
    width: calc(100% - 20px);
    bottom: 118px;
    /* bottom:60px; */
  }

  .usersBorderWhite,
  .usersBorderGray {
    border: unset;
  }

  .form {
    flex-direction: row;
    height: auto;
  }

  .form>div {
    margin-top: 5px;
  }

  .message__recipient,
  .message__sender {
    /* min-width: 100px !important; */
    max-width: 80% !important;
    min-width: 60% !important;
    /* min-width:80% !important; */
  }

  .chat__header {
    font-size: 13px;
  }

  .chat__footer {
    height: auto;
    /* padding-bottom:5px; */
  }

  .chat__mainHeader {
    display: none;
  }

  .chat {
    flex-direction: column;
    /* height: calc(100vh - 80px); */
    height: calc(100vh - 59px);

  }

  .rotate180 {
    transform: rotate(180deg)
  }

  .chat__sidebar {
    /* position:absolute;
    z-index:1;
    right:0;
  /* box-shadow: 0px 4px 9px rgb(0 0 0 / 9%); */
    /* top:5px; */
    /* width:30vw; */
    width: 100%;
    position: absolute;
    z-index: 900;
    /* background: linear-gradient(200.96deg, #eee -29.09%, #fff 51.77%, #eee 129.35%); */
    /* right: 0; */
    /* flex: 0.3; */
    /* top: 27px; */
    width: 100% !important;
  }

  .whiteThemeBoxShadow {
    box-shadow: 0px 1px 4px rgb(0 0 0 / 9%);
  }

  .grayThemeBoxShadow {
    box-shadow: 0px 1px 4px rgb(200 200 200 / 20%);

  }

  .chat__main {
    flex: 1 1;
    width: 100%;
  }

  .userButton {
    display: block;
    /* position: absolute;
    top:10px;
    right:10px; */
    padding: 8px;
    width: 45px;
    border-radius: 8px;
    border: 2px solid #ccc;
    margin: 10px;
    cursor: pointer;
    display: flex;

  }

  .absolutePlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 1005;
    height: 100%;
  }

  .closeBtn {
    display: flex;
  }

  .sendBtn {
    margin-top: 10px;
  }

  #fileUploadChat {
    margin: 0 auto !important;
  }

  .message__container {
    width: 100%;
    height: calc(100vh - 150px) !important;
    min-height: calc(100vh - 150px) !important;

  }

  .onlineLoader {
    height: calc(100vh - 150px) !important;
  }
}

.disabledBtn,
.disabledBtn:hover {
  background-color: #ccc !important;
  cursor: default !important;
}

.container {
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  display: inline-block;
  height: fit-content;


}

.wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  height: 100%;


}

.connectionError {
  position: absolute;
  top: 0px;
  left: 0;
  height: auto;
  width: 100vw;
  z-index: 1;
  background-color: rgb(247 221 221);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding: 10px;

}

.topError {
  top: 60px !important;
}

.prefix,
.affix {
  display: flex;
  justify-content: center;
  align-items: center;
}

input {
  background-color: transparent;
  width: 100%;
  border: none;
}

input:focus-visible {
  outline: 0;
}

input::placeholder {
  color: #bababa;
}

@media screen and (max-width: 800px) {

  input {
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 20px;


    /* Gray 4 */

    color: #BDBDBD;

  }


}`, "",{"version":3,"sources":["webpack://./../src/renderer/onlineChat.css"],"names":[],"mappings":"AAAA,2HAA2H;;AAE3H;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;GAEG;AACH;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yCAAyC;EACzC,gCAAgC;AAClC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB;8BAC4B;EAC5B,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;;EAEZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,oBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,sBAAsB;;EAEtB;2BACyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,iCAAiC;EACjC,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB;gCAC8B;EAC9B,aAAa;EACb,UAAU;EACV,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB;;;;;MAKI;EACJ,0EAA0E;;EAE1E,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;AAC5B,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;;AAEnB;AACA;EACE,eAAe;AACjB;;;AAGA;;GAEG;AACH;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;MACX,gBAAgB;EACpB,qBAAqB;AACvB;;AAEA;;GAEG;AACH;EACE;;eAEa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;;;;EAIE;;;;;;;;;;;;;6BAa2B;;EAE3B,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;;;AAGjC;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;;AAExB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,cAAc;EACd,eAAe;;EAEf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB;AACF;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;;;;;GAOG;AACH;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,eAAe;EACf,cAAc;;EAEd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT;AACF;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,aAAa;;EAEb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,wBAAwB;;AAE1B;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;;AAEb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0CAA0C;EAC1C;qBACmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;;EAEtB,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;EACf,qDAAqD;;EAErD,2BAA2B;EAC3B,sBAAsB;;EAEtB,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;;AAEpB;;AAEA;;;;;;;;;;;;;;;;;;GAkBG;;AAEH;;;;;GAKG;AACH;EACE,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB;;uBAEqB;;EAErB,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;;AAEhC;;AAEA;;;GAGG;AACH;;EAEE,sBAAsB;EACtB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;;;;;GAQG;AACH;EACE;IACE,eAAe;EACjB;;EAEA;IACE;;;+CAG2C;IAC3C,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,aAAa;IACb,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iCAAiC;IACjC,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,0BAA0B;;EAE5B;;EAEA;IACE;EACF;;EAEA;IACE;;;+CAG2C;IAC3C,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,qFAAqF;IACrF,cAAc;IACd,eAAe;IACf,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,8CAA8C;;EAEhD;;EAEA;IACE,SAAO;IACP,WAAW;EACb;;EAEA;IACE,cAAc;IACd;;iBAEa;IACb,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,aAAa;;EAEf;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,sCAAsC;IACtC,0CAA0C;;EAE5C;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;;;AAGrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;;;AAGd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;;AAEf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;;IAGjB,WAAW;;IAEX,cAAc;;EAEhB;;;AAGF","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap'); */\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  /* font-family: 'Poppins', sans-serif; */\n}\n\n.cursorDefault {\n  cursor: default !important;\n  border-radius: 50% !important;\n}\n\n/* .chatpage {\n  border-top: 1px solid #eee;\n} */\n.mobileView svg:not(.moreBox){\n  /* // fill: #fff !important; */\n  color: #000000 !important;\n  filter: brightness(0) invert(1) !important\n  /* // stroke: #fff !important; */\n}\n.mobileView div:not(.ThemeBox) p:not(.preserveStyle), .mobileView input, .mobileView input::placeholder {\n  color: #fff !important;\n}\n.exitButton {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  /* color: #D8000D;\n  border: 1px solid #D8000D; */\n  color: white;\n  background-color: #d8000d;\n  /* background: #FFFFFF; */\n  border-radius: 4px;\n  width: 134px;\n  ;\n  height: auto;\n  aspect-ratio: 4;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-right: auto;\n  cursor: pointer;\n}\n\n.date {\n  font-size: 11px;\n  width: auto;\n}\n\n.lastMessage {\n  color: #999 !important;\n  font-size: 12px !important;\n}\n\n.flex-1 {\n  flex: 1 !important;\n}\n\n.chatbarText {\n  margin: 0 8px;\n}\n\n.home__container {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.home__container>* {\n  margin-bottom: 10px;\n}\n\n.home__header {\n  margin-bottom: 30px;\n}\n\n.username__input {\n  padding: 10px;\n  width: 50%;\n}\n\n.home__cta {\n  width: 200px;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #607EAA;\n  color: #fbfbfb;\n  outline: none;\n  border: none;\n  border-radius: 5px;\n}\n\n.chat {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.userButton {\n  display: none;\n}\n\n.closeBtn {\n  display: none;\n}\n\n.chat__sidebar {\n  height: 100%;\n  box-sizing: border-box;\n  /* padding:0 20px; */\n  /* background-color: #fbfbfb; */\n  /* flex: 0.2; */\n  /* width:20%; */\n  /* padding: 20px; */\n  /* border-right: 1px solid #fdfdfd; */\n  /* overflow-y: auto; */\n\n  /* scrollbar-color: #e3e3e3 transparent;\n    scrollbar-width: 5px; */\n}\n\n.chat__sidebar>div {\n  /* height:100%; */\n}\n\n.flex-02 {\n  /* flex: 0.3; */\n  width: 24%;\n}\n\n.noContent {\n  display: block;\n}\n\n.chat__main {\n  height: 100%;\n  flex: 1;\n  /* padding-bottom: 10px; */\n  width: 70vw;\n}\n\n.chat__header {\n  /* margin: 30px 0 20px 0; */\n}\n\n.chat__users {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  overflow-y: auto;\n  height: calc(100vh - 134px);\n  /* height: calc(100vh - 200px); */\n  /* scrollbar-color: #e3e3e3 transparent; */\n  scrollbar-width: 5px;\n  margin-top: 5px;\n}\n\n.onlineLoader {\n  height: calc(100vh - 150px);\n}\n\n.chat__users>* {\n  margin-bottom: 5px;\n  margin-top: 5px;\n  /* color: #607EAA !important; */\n  font-size: 14px;\n}\n\n.chat__users p {\n  margin-right: 5px;\n}\n\n.chat__users>div {\n  width: 100%;\n  margin: 10px 0;\n  height: auto;\n  padding: 10px 10px;\n  margin: 10px 0;\n  border-radius: 4px;\n}\n\n.chat__users::-webkit-scrollbar {\n\n  background: transparent;\n  width: 5px;\n}\n\n.chat__users::-webkit-scrollbar-thumb {\n  background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 5px;\n}\n\n.online__users>* {\n  margin-bottom: 10px;\n  color: rgb(238, 102, 102);\n  font-style: italic;\n}\n\n.chat__mainHeader {\n  width: 100%;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  /* background-color: #fbfbfb; */\n}\n\n.footer__border {\n  /* border-top: 1px solid #ddd; */\n}\n\n.chatBarInput input {\n  min-height: 28px;\n}\n\n.replyChatStyle {\n  color: #d8000d;\n  cursor: pointer;\n  font-size: 11px;\n  /* width:20px; */\n  /* height:20px; */\n}\n\n.replyBox {\n  /* position: absolute; */\n  /* width: 100%; */\n  width: calc(100% - 20px);\n  /* height: 50px; */\n  /* bottom: 83px; */\n  bottom: 90px;\n  left: 10px;\n  /* padding: 14px; */\n  /* border-top-right-radius: 8px;\n  border-top-left-radius: 8px; */\n  display: flex;\n  z-index: 2;\n  /* flex-direction: column; */\n  /* justify-content: flex-start; */\n  /* align-items: flex-start; */\n  justify-content: space-between;\n  align-items: center;\n  /* background: linear-gradient(\n    200.96deg,\n    #eee -29.09%,\n    #fff 51.77%,\n    #eee 129.35%\n  ); */\n  /* box-shadow: 0px 0px 2px rgb(0 0 0 / 9%), 0px 1px 5px rgb(0 0 0 / 9%); */\n\n  /* box-shadow: 0px 4px 9px rgb(0 0 0 / 9%); */\n}\n\n.blockFooter {\n  padding-top: 10px;\n  margin-top: auto;\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  text-decoration: unset !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.blockFooter p {\n  cursor: pointer;\n  width: auto !important;\n}\n\n.replyBox p,\n.replyBox div {\n  font-size: 12px;\n  /* word-break: break-all; */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  /* display: -webkit-box; */\n  display:flex;\n  -webkit-line-clamp: 2;\n  -moz-text-size-adjust: auto;\n  /* text-align: right; */\n  /* width: 100%; */\n  /* padding: 0 10px; */\n  color: rgba(0, 0, 0, 0.50);\nfont-size: 11px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n\n}\n.replyBox> div{\n  padding: 0 10px;\n}\n\n\n/* .replyBox svg{\n  rotate: 180deg;\n} */\n.replyFile {\n  max-width: 10%;\n  height: auto !important;\n  margin-right: 10px;\n  margin-left: 10px;\n  max-width: 40px; \n      max-height: 40px;\n  /* max-height:78px; */\n}\n\n/* .replyFile img, .replyFile video{\n  max-height:78px;\n} */\n.unseenMessages {\n  /* position:absolute;\n  bottom:-5px;\n  right:-5px; */\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  color: #fff;\n  /* background-color: #e86e77; */\n  width: 19px;\n  height: 19px;\n  font-size: 11px;\n  border-radius: 50%;\n\n}\n\n.onlineUser {\n\n\n\n  /* position: absolute;\n    bottom: -2px;\n    width: 12px;\n    height: 12px;\n    right: -2px;\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    padding: 2px;\n    color: #fff;\n    font-size: 11px;\n    border-radius: 50%;\n    background-color: #19e219;\n    border: 1px solid #fff; */\n\n  position: absolute;\n  bottom: -1px;\n  width: 9px !important;\n  height: 9px !important;\n  /* left: 0px; */\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  color: #fff;\n  /* background-color: #075b52; */\n  font-size: 11px;\n  border-radius: 50%;\n  background-color: #19e219;\n  /* /* border: 1px solid #fff; */\n\n\n}\n\n.offlineUser {\n\n  position: absolute;\n  bottom: -2px;\n  width: 12px;\n  height: 12px;\n  right: -2px;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  color: #fff;\n  background-color: #dfc8c8;\n  font-size: 11px;\n  border-radius: 50%;\n  border: 2px solid #777;\n\n}\n\n.commentReply {\n\n  /* color: #aaa; */\n  color: #607EAA !important;\n  padding: 0 5px;\n  margin: 5px 0;\n  padding: 0 5px;\n  font-size: 11px;\n\n  width: 100%;\n  overflow: hidden;\n}\n\ncode,\npre {\n  white-space: pre;\n  font-family: IranSans_Light\n}\n\n#text {\n  word-break: break-all;\n  display: flex;\n  flex-wrap: wrap;\n  display: inline;\n}\n\n.onlineUserRtl {\n  left: 0 !important;\n  right: unset !important;\n}\n\n.onlineUserLtr {\n  left: unset !important;\n  right: 0 !important;\n}\n\n.rtl .commentReply {\n  border-left: 3px solid #607EAA;\n}\n\n.ltr .commentReply {\n  /* border-right: 3px solid #607EAA; */\n}\n\n/* .rtl .commentReply>div:nth-child(1){\n  margin-bottom: 10px;\n  margin-left: auto;\n}\n.ltr .commentReply>div:nth-child(1){\n  margin-bottom: 10px;\n  margin-right: auto;\n} */\n.commentReply p {\n\n  /* color: #aaa; */\n  color: #607EAA !important;\n  margin-bottom: 2px;\n  margin-top: 2px;\n\n}\n\n.leaveChat__btn {\n  padding: 10px;\n  width: 150px;\n  border: none;\n  outline: none;\n  background-color: #D1512D !important;\n  cursor: pointer;\n  color: #EAE3D2;\n\n  width: 150px;\n  padding: 10px;\n  /* border: none; */\n  /* outline: none; */\n  /* color: #EAE3D2; */\n  cursor: pointer;\n  color: #fff;\n  height: 100%;\n  margin-right: auto !important;\n  display: flex !important;\n}\n\n.message__container {\n  width: 100%;\n  height: calc(100vh - 140px);\n  min-height: calc(100vh - 140px);\n  /* background-color: #fff; */\n  /* padding: 20px; */\n  overflow-y: auto;\n  /* scrollbar-color: #e3e3e3 transparent; */\n  display: flex;\n  justify-content: flex-start;\n  /* align-items: flex-start; */\n  flex-direction: column;\n  scrollbar-width: 8px;\n}\n\n.message__containerScrollbarW {\n  scrollbar-color: #e3e3e3 transparent;\n}\n\n.message__containerScrollbarD {\n  scrollbar-color: #555555 transparent;\n}\n\n.userMessage {\n  padding: 4px 8px;\n  width: auto;\n  background-color:#909090;\n  /* background: rgba(0, 0, 0, 0.6); */\n  border-radius: 28px;\n  color: #fff;\n  /* min-width: 35%; */\n  width:auto;\n  margin: 4px auto;\n  font-size: 14px;\n}\n\n.dragFileElement {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1rem;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  background-color: rgba(200, 200, 200, 0.5)\n}\n\n.repeatBg {\n  /* background-size: 200px !important; */\n  background-repeat: repeat;\n  background-position: unset;\n}\n\n.noRepeatBg {\n  /* background-size: 543px !important; */\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.coverBg {\n  background-size: cover !important;\n}\n\n.message__container::-webkit-scrollbar {\n\n  background: transparent;\n  width: 8px;\n}\n\n.message__container::-webkit-scrollbar-thumb {\n  /* background-color: #e3e3e3; */\n  border-radius: 100px;\n  height: 8px;\n}\n\n.message__container>* {\n  /* margin-bottom: 10px; */\n}\n\n.chat__footer {\n  /* padding: 10px 0; */\n  padding-bottom: 0px;\n  /* background-color: #fbfbfb; */\n  height: 60px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.form {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.message {\n  width: 80%;\n  height: 100%;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  outline: none;\n  padding: 15px;\n  height: 36px;\n}\n\n.sendBtn {\n  width: 150px;\n  /* background-color: green !important; */\n  padding: 10px;\n\n  cursor: pointer;\n  color: #fff;\n  height: 100%;\n  display: flex !important;\n  border: unset !important;\n\n}\n\n.message__recipient video,\n.message__sender video {\n  margin: 0 auto !important;\n  height: auto !important;\n  width: 100%;\n}\n\n.commentReply img,\n.commentReply video {\n  margin-left: 10px !important;\n  /* margin-right:auto !important; */\n  width: 100%;\n\n}\n\n.message__recipient img,\n.message__sender img {\n  width: 100%;\n}\n\n.sendBtn:hover {\n  background-color: rgb(129, 201, 129) !important;\n}\n\n.message__recipient {\n  /* background-color: #f5ccc2 !important; */\n  /* min-width: 300px !important;\n  max-width: 350px; */\n  min-width: 225px !important;\n  max-width: 250px;\n  width: auto;\n  padding: 10px 8px;\n  padding-top: 20px;\n  border-radius: 10px;\n  font-size: 15px;\n  /* word-break: break-all; */\n  /* overflow: hidden; */\n\n  float: right;\n  clear: both;\n  border-top-right-radius: 0px;\n  /* background: #00D025; */\n  position: relative;\n  border-top-left-radius: 0px;\n}\n\n.message__sender {\n  /* background-color: rgb(194, 243, 194); */\n  min-width: 225px !important;\n  max-width: 250px;\n  padding: 10px 8px;\n  padding-top: 20px;\n  width: auto;\n  border-radius: 10px;\n  border-top-right-radius: 0px;\n  /* margin-left: auto; */\n  font-size: 15px;\n  /* background-color: rgb(129, 201, 129) !important; */\n\n  /* word-break: break-all; */\n  /* overflow: hidden; */\n\n  float: left;\n  clear: both;\n  border-top-left-radius: 0px;\n  position: relative;\n\n}\n\n/* .chat.u2{\n  float: right;\n  clear: both;\n  border-top-right-radius: 0px;\n  background: #00D025;\n}\n.chat.u2:before{\n  content: \"\";\n  width: 0px;\n  height: 0px;\n  display: block;\n  border-left: 5px solid #00D025;\n  border-right: 5px solid transparent;\n  border-top: 5px solid #00D025;\n  border-bottom: 5px solid transparent;\n  position: absolute;\n  top: 0px;\n  right: -10px;\n} */\n\n/* .senderBackgroundGray{\n  background-color: rgba(255,255,255,0.2) !important;\n}\n.senderBackgroundWhite{\n  background-color: rgba(0,0,0,0.1) !important;\n} */\n.message__chats {\n  padding: 10px 0;\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n  height: auto;\n  cursor: alias;\n}\n\n.message__chats>p {\n  font-size: 13px;\n  line-height: 20px;\n}\n\n.sender__name {\n  text-align: right;\n}\n\n.message__status {\n  /* position: fixed; */\n  /* bottom: 50px;\n  font-size: 13px;\n  font-style: italic; */\n\n  position: fixed !important;\n  bottom: 70px;\n  margin: 0 10px;\n  font-size: 13px;\n  font-style: italic;\n\n}\n\n.onlineChatInput {\n  color: #fff;\n}\n\n.custom-file-upload input[type=\"file\"] {\n  display: none;\n}\n\n.custom-file-upload {\n  width: fit-content;\n  cursor: pointer;\n  border-radius: 24px;\n  border: 1px solid #eeeeee;\n  padding: 8px 18px;\n  margin: 4px;\n  background-color: #fafafa;\n  font-size: 14px;\n  display: inline-block;\n  height: 36px;\n  /* width: 150px; */\n  background-color: inherit !important;\n  /* border: 1px solid green; */\n  /* border: none; */\n  /* outline: none; */\n  /* color: #EAE3D2; */\n  cursor: pointer;\n  /* color: green; */\n  display: flex !important;\n  justify-content: center;\n  min-width: 64px;\n  /* border: unset !important; */\n\n}\n\n/* .custom-file-upload:hover {\n  color: rgb(129, 201, 129) !important;\n  border: 1px solid rgb(129, 201, 129);\n} */\n.disableUpload,\n.disableUpload:hover {\n  color: #ccc !important;\n  border: 1px solid #ccc !important;\n  cursor: default !important;\n}\n\n.usersBorderWhite {\n  margin-top: 10px;\n  /* border-left: 1px solid #ccc; */\n}\n\n.usersBorderGray {\n  /* border-left: 1px solid #555; */\n}\n\n/* @media only screen and (max-width: 850px) {\n  .message__container {\n    width: 100%;\n    height: calc( 100% - 56px) !important;\n  }\n  .onlineLoader{\n    height: calc( 100% - 56px) !important;\n  }\n} */\n@media only screen and (max-width: 800px) {\n  .chat {\n    /* flex:0.75; */\n  }\n\n  .chat__sidebar {\n    /* position:absolute;\n    z-index:1;\n    right:0;\n  /* box-shadow: 0px 4px 9px rgb(0 0 0 / 9%); */\n    /* top:5px; */\n    /* width:30vw !important; */\n  }\n\n  .replyBox {\n    width: calc(100% - 20px);\n    bottom: 90px;\n    /* bottom: 106px; */\n    /* bottom: 103px; */\n  }\n\n  .flex-02 {\n    /* flex: 0.3; */\n    width: 34%;\n  }\n}\n\n@media only screen and (max-width: 650px) {\n  .noContent {\n    display: none;\n  }\n\n  .replyBox {\n    width: calc(100% - 20px);\n    bottom: 118px;\n    /* bottom:60px; */\n  }\n\n  .usersBorderWhite,\n  .usersBorderGray {\n    border: unset;\n  }\n\n  .form {\n    flex-direction: row;\n    height: auto;\n  }\n\n  .form>div {\n    margin-top: 5px;\n  }\n\n  .message__recipient,\n  .message__sender {\n    /* min-width: 100px !important; */\n    max-width: 80% !important;\n    min-width: 60% !important;\n    /* min-width:80% !important; */\n  }\n\n  .chat__header {\n    font-size: 13px;\n  }\n\n  .chat__footer {\n    height: auto;\n    /* padding-bottom:5px; */\n  }\n\n  .chat__mainHeader {\n    display: none;\n  }\n\n  .chat {\n    flex-direction: column;\n    /* height: calc(100vh - 80px); */\n    height: calc(100vh - 59px);\n\n  }\n\n  .rotate180 {\n    transform: rotate(180deg)\n  }\n\n  .chat__sidebar {\n    /* position:absolute;\n    z-index:1;\n    right:0;\n  /* box-shadow: 0px 4px 9px rgb(0 0 0 / 9%); */\n    /* top:5px; */\n    /* width:30vw; */\n    width: 100%;\n    position: absolute;\n    z-index: 900;\n    /* background: linear-gradient(200.96deg, #eee -29.09%, #fff 51.77%, #eee 129.35%); */\n    /* right: 0; */\n    /* flex: 0.3; */\n    /* top: 27px; */\n    width: 100% !important;\n  }\n\n  .whiteThemeBoxShadow {\n    box-shadow: 0px 1px 4px rgb(0 0 0 / 9%);\n  }\n\n  .grayThemeBoxShadow {\n    box-shadow: 0px 1px 4px rgb(200 200 200 / 20%);\n\n  }\n\n  .chat__main {\n    flex: 1;\n    width: 100%;\n  }\n\n  .userButton {\n    display: block;\n    /* position: absolute;\n    top:10px;\n    right:10px; */\n    padding: 8px;\n    width: 45px;\n    border-radius: 8px;\n    border: 2px solid #ccc;\n    margin: 10px;\n    cursor: pointer;\n    display: flex;\n\n  }\n\n  .absolutePlay {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 1005;\n    height: 100%;\n  }\n\n  .closeBtn {\n    display: flex;\n  }\n\n  .sendBtn {\n    margin-top: 10px;\n  }\n\n  #fileUploadChat {\n    margin: 0 auto !important;\n  }\n\n  .message__container {\n    width: 100%;\n    height: calc(100vh - 150px) !important;\n    min-height: calc(100vh - 150px) !important;\n\n  }\n\n  .onlineLoader {\n    height: calc(100vh - 150px) !important;\n  }\n}\n\n.disabledBtn,\n.disabledBtn:hover {\n  background-color: #ccc !important;\n  cursor: default !important;\n}\n\n.container {\n  background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  display: inline-block;\n  height: fit-content;\n\n\n}\n\n.wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 10px;\n  height: 100%;\n\n\n}\n\n.connectionError {\n  position: absolute;\n  top: 0px;\n  left: 0;\n  height: auto;\n  width: 100vw;\n  z-index: 1;\n  background-color: rgb(247 221 221);\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  padding: 10px;\n\n}\n\n.topError {\n  top: 60px !important;\n}\n\n.prefix,\n.affix {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\ninput {\n  background-color: transparent;\n  width: 100%;\n  border: none;\n}\n\ninput:focus-visible {\n  outline: 0;\n}\n\ninput::placeholder {\n  color: #bababa;\n}\n\n@media screen and (max-width: 800px) {\n\n  input {\n    font-style: normal;\n    font-weight: 300;\n    font-size: 12px;\n    line-height: 20px;\n\n\n    /* Gray 4 */\n\n    color: #BDBDBD;\n\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
